import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["connections"];
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import ABTestBranch from 'automation-ui-action-features/records/ABTestBranch';
import BranchConnectionMixin, { BranchConnectionMixinDefaultValues, branchConnectionFromJSON } from 'automation-ui-action-features/records/connection/BranchConnectionMixin';
import { List } from 'immutable';
const ABTestBranchConnectionDefaultValues = Object.assign({}, BranchConnectionMixinDefaultValues, {
  connections: [new ABTestBranch(), new ABTestBranch()]
});
export default class ABTestBranchConnection extends BranchConnectionMixin(createImmutableObjectClass(ABTestBranchConnectionDefaultValues, {
  fromJSON: _ref => {
    let {
        connections
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({}, rest, branchConnectionFromJSON(rest), {
      connections: (connections || [new ABTestBranch(), new ABTestBranch()]).map(branchJSON => new ABTestBranch(branchJSON))
    });
  },
  toJSON: _ref2 => {
    let rest = Object.assign({}, (_objectDestructuringEmpty(_ref2), _ref2));
    return Object.assign({}, rest);
  }
})) {
  getBranches() {
    return List(this.connections);
  }
  setBranches(staticBranches) {
    return this.set('connections', staticBranches.toArray());
  }
  getPlaceholderBranchName() {
    // for now, we only support even split random branches
    return `${Math.round(100 / this.connections.length)}%`;
  }
}